<label class="block max-w-screen-sm">
  <select
    class="form-select pl-4 py-2.5 block w-full mt-1 bg-neutral-100 rounded-full font-base text-base font-normal"
    [(ngModel)]="selectedItem"
    [disabled]="isDisable"
    (change)="onChange()"
  >
    <option
      *ngFor="let item of items"
      [ngValue]="item.value"
    >
      {{ item.label | translate }}
    </option>
  </select>
</label>
